import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCRulf extends NPC {
    constructor() {
        super(definitions.NPC_ID.RULF);

        this.collisionRadius = 10;
        this.collisionOffsetX = -4;
        this.collisionOffsetY = -28;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_rulf_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(-4, -12));
        this.animateIdle(0.35);
    }
}